import script from "./ConfirmActionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmActionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmActionPopup.vue?vue&type=style&index=0&id=3f067a54&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f067a54"]])

export default __exports__